
/**
 * Search for a key in a collection by comparing it to a slug.
 * 
 * @param collection The collection to search in.
 * @param slug The slug to search for.
 * @returns The value of the key in the collection, or undefined if not found.
 */
export default function searchKeyInCollection<T>(
  collection: { [key: string]: T},
  slug: string
): T|undefined {

    const result = Object.keys(collection).find((key) => {
        // compare key and slug by ignoring case and removing accents
        if (key.localeCompare(slug, undefined, { sensitivity: "base" }) === 0) {
            return collection[key];
        }
    });

    if (!result) {
        return undefined;
    }

    return collection[result];
}